module.exports = __webpack_public_path__ + "img/B01_HQ02.18e90f9d.jpg";